import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

// Sample user data
import Ambassador1 from "@/assets/recentAmbassador/mujer1.webp";
import Ambassador2 from "@/assets/recentAmbassador/mujer2.webp";
import Ambassador3 from "@/assets/recentAmbassador/mujer3.webp";
import Ambassador4 from "@/assets/recentAmbassador/mujer4.webp";
import Ambassador5 from "@/assets/recentAmbassador/mujer5.webp";
import Ambassador6 from "@/assets/recentAmbassador/duo.webp";
import Ambassador7 from "@/assets/recentAmbassador/chris.webp";
const users = [
  { name: "Crisferrada", img: Ambassador1, following: false },
  { name: "Danielasoto", img: Ambassador2, following: false },
  { name: "ConiUp", img: Ambassador3, following: false },
  { name: "Mujer4", img: Ambassador4, following: false },
  { name: "Mujer5", img: Ambassador5, following: true },
  { name: "Duo", img: Ambassador6, following: true },
  { name: "Chris", img: Ambassador7, following: true },
  { name: "User8", img: Ambassador1, following: false },
  { name: "User9", img: Ambassador2, following: false },
  { name: "User10", img: Ambassador3, following: false },
  { name: "User11", img: Ambassador4, following: false },
  { name: "User12", img: Ambassador5, following: true },
  { name: "User13", img: Ambassador6, following: true },
  { name: "User14", img: Ambassador7, following: true },
];

export default function InvitarAmigos({ closeInvitarAmigos }) {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Filtrar usuarios basado en el término de búsqueda
  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Usuarios seleccionados para mostrar en la sección superior
  const selectedUsersData = selectedUsers.map((index) => ({
    ...users[index],
    originalIndex: index,
  }));

  // Resultados de búsqueda excluyendo usuarios ya seleccionados
  const searchResults = filteredUsers.filter((user) => {
    const originalIndex = users.findIndex(
      (originalUser) => originalUser === user
    );
    return !selectedUsers.includes(originalIndex);
  });

  const handleSelectUser = (idx) => {
    // Necesitamos encontrar el índice real en el array original de users
    const originalIndex = users.findIndex(
      (user) => user === filteredUsers[idx]
    );

    setSelectedUsers((prevSelected) => {
      if (prevSelected.includes(originalIndex)) {
        // Si ya está seleccionado, lo removemos
        return prevSelected.filter((index) => index !== originalIndex);
      } else {
        // Si no está seleccionado, lo agregamos (máximo 6)
        if (prevSelected.length >= 6) {
          return prevSelected; // No agregar más de 6
        }
        return [...prevSelected, originalIndex];
      }
    });
  };

  const handleDeselectUser = (originalIndex) => {
    setSelectedUsers((prevSelected) =>
      prevSelected.filter((index) => index !== originalIndex)
    );
  };

  const handleInvitarAmigos = () => {
    const selectedUserData = selectedUsers.map((index) => users[index]);
    console.log("Invitar a los usuarios seleccionados:", selectedUserData);
    // Aquí puedes agregar la lógica real de invitación
    closeInvitarAmigos();
  };

  return (
    <div className="w-full mx-auto flex flex-col items-center h-[77.25dvh] bg-aw-bluedark rounded-4xl pt-6 pb-4 px-2 select-none inset-shadow-sm inset-shadow-aw-green/60">
      <h2 className="text-2xl font-semibold text-aw-green mb-4 text-center">
        Invitar Amigos a mi Perfil
      </h2>
      {/* Input de búsqueda */}
      <div className="w-full mb-6 flex items-center justify-center">
        <div className="relative w-full max-w-xs">
          <input
            type="text"
            placeholder="Buscar Amistad para Invitar a mi perfil"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full rounded-xl border border-aw-green py-2 pl-4 pr-10 text-aw-green text-center text-base focus:outline-none focus:ring-2 focus:ring-aw-green placeholder:text-aw-green/50"
          />
          <FontAwesomeIcon
            icon={faSearch}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-aw-green/50 text-lg"
          />
        </div>
      </div>
      {/* Grid de usuarios */}
      <div className="w-full px-4 mb-6 overflow-auto scrollbar-box thin flex-1">
        {/* Sección de usuarios seleccionados */}
        {selectedUsers.length > 0 && (
          <div className="mb-6">
            <h3 className="text-aw-green text-sm font-semibold mb-3 text-center">
              Usuarios Seleccionados ({selectedUsers.length}/6)
            </h3>
            <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-8 gap-y-4 gap-x-2">
              {selectedUsersData.map((user) => (
                <div
                  key={user.originalIndex}
                  className="flex flex-col items-center transition-all duration-200"
                  onClick={() => handleDeselectUser(user.originalIndex)}
                >
                  <div className="w-20 h-20 rounded-full border-4 border-aw-green ring-4 ring-aw-green-30 flex items-center justify-center overflow-hidden mb-1 bg-white cursor-pointer transition-all duration-200">
                    <img
                      src={user.img}
                      alt={user.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="text-xs font-semibold truncate w-20 text-center text-aw-green">
                    {user.name}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-center mt-4 text-center">
              {selectedUsers.length === 6 && (
                <span className="block text-aw-green text-xs">
                  Puedes invitar hasta 6 amigos por ocasión
                </span>
              )}
            </div>
          </div>
        )}

        {/* Sección de búsqueda - solo aparece cuando hay texto en el buscador */}
        {searchTerm.trim() && (
          <div>
            <h3 className="text-white text-sm font-semibold mb-3 text-center">
              Resultados de Búsqueda
            </h3>
            <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-8 gap-y-4 gap-x-2">
              {searchResults.length > 0 ? (
                searchResults.map((user) => {
                  const originalIndex = users.findIndex(
                    (originalUser) => originalUser === user
                  );
                  const canSelect = selectedUsers.length < 6;
                  return (
                    <div
                      key={originalIndex}
                      className={`flex flex-col items-center transition-all duration-200 ${
                        !canSelect ? "opacity-50" : ""
                      }`}
                      onClick={() =>
                        canSelect &&
                        handleSelectUser(
                          filteredUsers.findIndex((u) => u === user)
                        )
                      }
                    >
                      <div
                        className={`w-20 h-20 rounded-full border-4 border-gray-300 flex items-center justify-center overflow-hidden mb-1 bg-white transition-all duration-200 ${
                          canSelect
                            ? "cursor-pointer hover:border-aw-green"
                            : "cursor-not-allowed"
                        }`}
                      >
                        <img
                          src={user.img}
                          alt={user.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="text-xs font-semibold truncate w-20 text-center text-white">
                        {user.name}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-span-3 text-center text-white/60 py-4">
                  No se encontraron usuarios
                </div>
              )}
            </div>
          </div>
        )}

        {/* Vista por defecto cuando no hay búsqueda */}
        {!searchTerm.trim() && (
          <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-8 gap-y-6 gap-x-2 pt-4">
            {users
              .filter((user, i) => !selectedUsers.includes(i))
              .map((user) => {
                const originalIndex = users.findIndex(
                  (originalUser) => originalUser === user
                );
                const canSelect = selectedUsers.length < 6;
                return (
                  <div
                    key={originalIndex}
                    className={`flex flex-col items-center transition-all duration-200 ${
                      !canSelect ? "opacity-50" : ""
                    }`}
                    onClick={() => canSelect && handleSelectUser(originalIndex)}
                  >
                    <div
                      className={`w-20 h-20 rounded-full border-4 border-gray-300 flex items-center justify-center overflow-hidden mb-1 bg-white transition-all duration-200 ${
                        canSelect
                          ? "cursor-pointer hover:border-aw-green"
                          : "cursor-not-allowed"
                      }`}
                    >
                      <img
                        src={user.img}
                        alt={user.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="text-xs font-semibold truncate w-20 text-center text-white">
                      {user.name}
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
      {/* Botón cancelar/Invitar */}
      {selectedUsers.length === 0 ? (
        <button
          onClick={closeInvitarAmigos}
          className="w-full max-w-xs bg-aw-bluedark-50 text-aw-green text-lg font-semibold rounded-xl py-3 mt-auto tracking-widest cursor-pointer hover:scale-95 duration-300"
        >
          CANCELAR
        </button>
      ) : (
        <>
          <button
            onClick={handleInvitarAmigos}
            className="w-full max-w-xs bg-aw-green text-aw-bluedark text-lg font-semibold rounded-xl py-3 mt-auto tracking-widest cursor-pointer hover:scale-95 duration-300"
          >
            Invitar ({selectedUsers.length})
          </button>
        </>
      )}
    </div>
  );
}
